<div class="web-delivery-timeline">
    <div class="requirements">
        <a
            href="https://rpcandidate.prometric.com/"
            target="_blank"
        >Test Your System </a> to ensure your computer and network will allow testing.
        <hr style="padding-bottom:20px" />
    </div>
    <div [ngClass]="{'card' : true, 'pending' : (reg.uploadedPhotoStatus == ScannedDocumentStatusEnum.Submitted), 'action-now' : (reg.uploadedPhotoStatus == ScannedDocumentStatusEnum.Rejected || reg.uploadedPhotoStatus == ScannedDocumentStatusEnum.Pending), 'complete' : (reg.uploadedPhotoStatus == ScannedDocumentStatusEnum.Approved) }">
        <div class="timeline-icon-section">
            <div
                class="photo-capture-step"
                [ngClass]="{'vl' : true, 'pending' : (reg.uploadedPhotoStatus == ScannedDocumentStatusEnum.Submitted), 'action-now' : (reg.uploadedPhotoStatus == ScannedDocumentStatusEnum.Rejected || reg.uploadedPhotoStatus == ScannedDocumentStatusEnum.Pending), 'complete' : (reg.uploadedPhotoStatus == ScannedDocumentStatusEnum.Approved) }"
            >
                <div [ngClass]="{'time-label' : true, 'hide-time': (reg.uploadedPhotoStatus !== ScannedDocumentStatusEnum.Rejected && reg.uploadedPhotoStatus != ScannedDocumentStatusEnum.Pending)}">
                    <div
                        class="sub-label"
                        style="text-align: center;"
                    >Due by</div>
                    <div class="sub-label">{{photoDueDate}}</div>
                    <div class="main-label">{{photoDueDate24hour}}</div>
                </div>
                <div [ngClass]="{'progress-circle' : true, 'pending' : (reg.uploadedPhotoStatus == ScannedDocumentStatusEnum.Submitted), 'action-now' : (reg.uploadedPhotoStatus == ScannedDocumentStatusEnum.Rejected || reg.uploadedPhotoStatus == ScannedDocumentStatusEnum.Pending), 'complete' : (reg.uploadedPhotoStatus == ScannedDocumentStatusEnum.Approved) }">
                    <span *ngIf="reg.uploadedPhotoStatus != ScannedDocumentStatusEnum.Approved">
                        <i
                            class="fa fa-camera-retro"
                            aria-hidden="true"
                        ></i>
                    </span>
                    <span *ngIf="reg.uploadedPhotoStatus == ScannedDocumentStatusEnum.Approved">
                        <i
                            class="fa fa-check"
                            aria-hidden="true"
                            style="font-size: 13px;position: relative;bottom: 1px;"
                        ></i>
                    </span>
                </div>
            </div>
        </div>
        <ng-template
            #content
            let-modal
        >
            <div class="modal-header">
                <h4 class="modal-title"> <i aria-hidden="true"></i> {{ showPhotoCapture ? "Photo Capture" : "Photo  Upload" }}</h4>
            </div>
            <div class="modal-body">
                <div *ngIf="!showPhotoCapture">
                    <app-document-upload-form
                        [regId]="reg.regId"
                        [regBlobDataTypeId]=RegBlobDataTypeEnum.PictureFromRegistration
                        (updateUploadStatus)="changeUploadedPhotoStatus()"
                    ></app-document-upload-form>
                </div>
                <div *ngIf="showPhotoCapture">
                    <app-photo-capture
                        [regId]="reg.regId"
                        (updateStatus)="changeUploadedPhotoStatus()"
                    ></app-photo-capture>
                </div>
            </div>
            <div class="
                        modal-footer">
                <button
                    type="button"
                    class="btn btn-primary"
                    (click)="modal.dismiss('Cross click')"
                >
                    Close
                </button>
            </div>
        </ng-template>
        <div class="card-content">
            <div
                *ngIf="reg.uploadedPhotoStatus == ScannedDocumentStatusEnum.Submitted"
                class="progress-title"
            > Photo under review</div>
            <div
                *ngIf="reg.uploadedPhotoStatus == ScannedDocumentStatusEnum.Rejected || reg.uploadedPhotoStatus == ScannedDocumentStatusEnum.Pending"
                class="progress-title"
            > Retake your photo</div>
            <div
                *ngIf="reg.uploadedPhotoStatus == ScannedDocumentStatusEnum.Approved"
                class="progress-title"
            > Photo approved</div>
            <hr />
            <div class="progress-details">
                <ul
                    *ngIf="reg.uploadedPhotoStatus == ScannedDocumentStatusEnum.Submitted"
                    style="padding-bottom: 0px;"
                >
                    <li>
                        We will review the submitted photo.
                    </li>
                    <li>
                        You will receive an email if your photo does not meet our requirements.
                    </li>
                </ul>

                <ul
                    *ngIf="reg.uploadedPhotoStatus == ScannedDocumentStatusEnum.Rejected || reg.uploadedPhotoStatus == ScannedDocumentStatusEnum.Pending"
                    style="padding-bottom: 0px;"
                >
                    <li>
                        Your photo did not meet our requirements. Please check your email for details.
                    </li>
                    <li>
                        Take a new photo before the deadline.
                    </li>
                </ul>

                <ul
                    *ngIf="reg.uploadedPhotoStatus == ScannedDocumentStatusEnum.Approved"
                    style="padding-bottom: 0px;"
                >
                    <li>
                        Your photo has been approved.
                    </li>
                </ul>
                <a
                    class="btn btn-default mr-2"
                    *ngIf="reg.uploadedPhotoStatus == ScannedDocumentStatusEnum.Rejected || reg.uploadedPhotoStatus == ScannedDocumentStatusEnum.Pending"
                    style="margin-bottom: 10px;position: relative;top: 8px;"
                    (click)="openModal(false)"
                >
                    Upload Photo
                </a>
                <a
                    class="btn btn-default"
                    *ngIf="reg.uploadedPhotoStatus == ScannedDocumentStatusEnum.Rejected || reg.uploadedPhotoStatus == ScannedDocumentStatusEnum.Pending"
                    style="margin-bottom: 10px;position: relative;top: 8px;"
                    (click)="openModal(true)"
                >
                    Take Photo
                </a>

                <br />
            </div>
        </div>
    </div>
    <div [ngClass]="{'card' : true, 'pending' : (reg.scannedDocumentStatus == ScannedDocumentStatusEnum.Submitted), 'action-now' : (reg.scannedDocumentStatus == ScannedDocumentStatusEnum.Rejected || reg.scannedDocumentStatus == ScannedDocumentStatusEnum.Pending), 'complete' : (reg.scannedDocumentStatus == ScannedDocumentStatusEnum.Approved) }">
        <div class="timeline-icon-section">
            <div
                class="scan-document-step"
                [ngClass]="{'vl' : true, 'pending' : (reg.scannedDocumentStatus == ScannedDocumentStatusEnum.Submitted), 'action-now' : (reg.scannedDocumentStatus == ScannedDocumentStatusEnum.Rejected || reg.scannedDocumentStatus == ScannedDocumentStatusEnum.Pending), 'complete' : (reg.scannedDocumentStatus == ScannedDocumentStatusEnum.Approved) }"
            >
                <div [ngClass]="{'time-label' : true, 'hide-time': (reg.scannedDocumentStatus !== ScannedDocumentStatusEnum.Rejected && reg.scannedDocumentStatus != ScannedDocumentStatusEnum.Pending)}">
                    <div
                        class="sub-label"
                        style="text-align: center;"
                    >Due by</div>
                    <div class="sub-label">{{idDueDate}}
                    </div>
                    <div class="main-label">{{idDueDate24hour}}</div>
                </div>
                <div [ngClass]="{'progress-circle' : true, 'pending' : (reg.scannedDocumentStatus == ScannedDocumentStatusEnum.Submitted), 'action-now' : (reg.scannedDocumentStatus == ScannedDocumentStatusEnum.Rejected || reg.scannedDocumentStatus == ScannedDocumentStatusEnum.Pending), 'complete' : (reg.scannedDocumentStatus == ScannedDocumentStatusEnum.Approved) }">
                    <span *ngIf="reg.scannedDocumentStatus != ScannedDocumentStatusEnum.Approved">
                        <i
                            class="fa fa-id-card"
                            aria-hidden="true"
                        ></i>
                    </span>
                    <span *ngIf="reg.scannedDocumentStatus == ScannedDocumentStatusEnum.Approved">
                        <i
                            class="fa fa-check"
                            aria-hidden="true"
                            style="font-size: 13px;position: relative;bottom: 1px;"
                        ></i>
                    </span>
                </div>
            </div>
        </div>

        <div class="card-content">
            <div
                *ngIf="reg.scannedDocumentStatus == ScannedDocumentStatusEnum.Submitted"
                class="progress-title"
            > Identification document under review</div>
            <div
                *ngIf="reg.scannedDocumentStatus == ScannedDocumentStatusEnum.Rejected || reg.scannedDocumentStatus == ScannedDocumentStatusEnum.Pending"
                class="progress-title"
            > Submit your identification document</div>
            <div
                *ngIf="reg.scannedDocumentStatus == ScannedDocumentStatusEnum.Approved"
                class="progress-title"
            > Identification document approved</div>
            <hr />
            <div class="progress-details">
                <ul
                    *ngIf="reg.scannedDocumentStatus == ScannedDocumentStatusEnum.Submitted"
                    style="padding-bottom: 0px;"
                >
                    <li>
                        We will review the uploaded identification document.
                    </li>
                    <li>
                        You will receive an email if your photo does not meet our requirements.
                    </li>
                </ul>

                <ul
                    *ngIf="reg.scannedDocumentStatus == ScannedDocumentStatusEnum.Rejected || reg.scannedDocumentStatus == ScannedDocumentStatusEnum.Pending"
                    style="padding-bottom: 0px;"
                >
                    <li>
                        Your uploaded identification document did not meet our requirements. Please check your email for details.
                    </li>
                    <li>
                        Upload a new identification document photo before the deadline.
                    </li>
                </ul>

                <ul
                    *ngIf="reg.scannedDocumentStatus == ScannedDocumentStatusEnum.Approved"
                    style="padding-bottom: 0px;"
                >
                    <li>
                        Your identification document has been approved.
                    </li>
                    <li>
                        You must show this same identification document at the start of your test.
                    </li>
                </ul>
                <a
                    class="btn btn-default"
                    *ngIf="reg.scannedDocumentStatus == ScannedDocumentStatusEnum.Rejected || reg.scannedDocumentStatus == ScannedDocumentStatusEnum.Pending"
                    style="margin-bottom: 10px;"
                    [routerLink]="['/account/reload-scanned-document',reg.regId]"
                >
                    <span style="padding-right:5px;"><i class="fa fa-upload"></i></span>Upload Scan
                </a>
                <br />
            </div>
        </div>
    </div>
    <div
        *ngIf="isUpcomingTest"
        [ngClass]="{'card' : true, 'pending' : (!testAvailableToStart || (reg.scannedDocumentStatus != ScannedDocumentStatusEnum.Approved)), 'action-now' : (testAvailableToStart && (reg.scannedDocumentStatus == ScannedDocumentStatusEnum.Approved)) }"
    >
        <div class="timeline-icon-section">
            <div
                class="test-entry-step"
                [ngClass]="{'vl' : true, 'pending' : (!testAvailableToStart || (reg.scannedDocumentStatus != ScannedDocumentStatusEnum.Approved )), 'action-now' : (testAvailableToStart && (reg.scannedDocumentStatus == ScannedDocumentStatusEnum.Approved ))}"
            >
                <div
                    class="time-label"
                    style="top: -23px;"
                >
                    <div
                        class="sub-label"
                        style="text-align: center;"
                    >Start time</div>
                    <div class="sub-label">{{testDueDate}}</div>
                    <div class="main-label">{{testStartTimeDisplay}}</div>
                </div>
                <div [ngClass]="{'progress-circle' : true, 'pending' : (!testAvailableToStart || (reg.scannedDocumentStatus == ScannedDocumentStatusEnum.Approved)) }">
                    <span>
                        <i
                            class="fa fa-laptop"
                            aria-hidden="true"
                        ></i>
                    </span>
                </div>
            </div>
        </div>
        <div class="card-content">
            <div class="progress-title">Start your test</div>
            <hr />
            <div
                *ngIf="myAccount.proctorId == 2"
                class="progress-details"
            >
                <ul style="padding-bottom: 2px;">
                    <li>
                        You will receive an email with instructions on downloading and installing the required test software two calendar days before your test date.
                    </li>
                    <li *ngIf="myAccount.proctorConfirmationNumber">
                        Your <strong style="text-decoration: underline;">Confirmation Number</strong> is <strong
                            id="confirmationNumber"
                            style="background-color: #808080;color: white;padding: 2px;"
                        >{{myAccount.proctorConfirmationNumber}}</strong> <i
                            class="fa fa-clipboard"
                            (click)="copyConfirmationNumber()"
                            aria-hidden="true"
                            style="cursor: pointer;color: grey;"
                        ></i>. Click <a
                            href="{{myAccount.webDeliveryUrl}}"
                            target="_blank"
                        > here </a> to download the ProProctor application that delivers your test with your <strong style="text-decoration: underline;">Confirmation Number</strong> to start your test.
                    </li>
                    <li>
                        You must start your test within 30 minutes of the start time, or you will not be able to take your test and will not be eligible for a refund or transfer.
                    </li>
                </ul>
                <br />
                <div id="testTimeNotInSoonModeSection">
                </div>
            </div>

            <div
                *ngIf="myAccount.proctorId != 2"
                class="progress-details"
            >
                <ul style="padding-bottom: 2px;">
                    <li>
                        You will be able to start your test at {{testDisplayTime}}.
                    </li>
                    <li>
                        You must start your test within 30 minutes of the start time, or you will not be able to take your test and will not be eligible for a refund or transfer.
                    </li>
                </ul>
                <button
                    id="testStartButton"
                    style="margin-top: 10px; margin-bottom: 10px; border-color: #ccc;"
                    [disabled]="(checkingUpcomingWebDeliveryTestState) || (!testAvailableToStart) || (reg.uploadedPhotoStatus != ScannedDocumentStatusEnum.Approved) || (reg.scannedDocumentStatus != ScannedDocumentStatusEnum.Approved) || (upcomingWebDeliveryTestState?.testEnded)"
                    (click)="startWebDelivery()"
                    class="btn btn-default"
                    type="button"
                >
                    <span *ngIf="!upcomingWebDeliveryTestState ||!upcomingWebDeliveryTestState?.testEnded"> START MY TEST </span> <span *ngIf="upcomingWebDeliveryTestState?.testEnded">TEST FINISHED </span>
                </button>
                <br />
                <div id="testTimeNotInSoonModeSection">
                </div>
            </div>
        </div>
    </div>
</div>
